import { Box, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import {
  IconLayoutDashboard, IconApps, IconPhotoSearch, IconBell,
  IconWorld, IconChartBar, IconSettings, IconWand,
} from '@tabler/icons-react';
import type { ReactNode } from 'react';

type NavItem = {
  id: string; label: string; icon: ReactNode;
  badge?: string;            // optional "Beta" or count
  disabled?: boolean;        // greyed out (not built yet)
};

const NAV: NavItem[] = [
  { id: 'dashboard',  label: 'Dashboard',  icon: <IconLayoutDashboard size={18} /> },
  { id: 'apps',       label: 'PWAs',       icon: <IconApps size={18} /> },
  { id: 'prelanders', label: 'Prelanders', icon: <IconPhotoSearch size={18} /> },
  { id: 'push',       label: 'Push',       icon: <IconBell size={18} /> },
  { id: 'domains',    label: 'Domains',    icon: <IconWorld size={18} /> },
  { id: 'funnel',     label: 'Funnel',     icon: <IconWand size={18} />, badge: 'New' },
  { id: 'reports',    label: 'Reports',    icon: <IconChartBar size={18} /> },
  { id: 'settings',   label: 'Settings',   icon: <IconSettings size={18} /> },
];

export function Sidebar({ active, onSelect }: { active: string; onSelect: (id: string) => void }) {
  return (
    <Box
      component="nav"
      style={{
        width: 220,
        flexShrink: 0,
        borderRight: '1px solid var(--mantine-color-gray-2)',
        background: 'var(--mantine-color-white)',
        padding: '20px 12px 16px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Group gap={10} mb="lg" px={8}>
        <Box
          style={{
            width: 30, height: 30, borderRadius: 9,
            background: 'linear-gradient(135deg,#3d78ff,#1450d3)',
            display: 'grid', placeItems: 'center', color: 'white',
            fontWeight: 800, fontSize: 15,
            boxShadow: '0 6px 14px rgba(61,120,255,0.35)',
          }}
        >C</Box>
        <Stack gap={0}>
          <Text fw={700} fz="md" lh={1.1}>Command</Text>
          <Text fz={10} c="dimmed" lh={1.1}>Center · v2</Text>
        </Stack>
      </Group>
      <Stack gap={2} style={{ flex: 1 }}>
        {NAV.map(item => {
          const isActive = item.id === active;
          return (
            <UnstyledButton
              key={item.id}
              onClick={() => !item.disabled && onSelect(item.id)}
              disabled={item.disabled}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 12px', borderRadius: 8,
                background: isActive ? 'var(--mantine-color-brand-0)' : 'transparent',
                color: isActive ? 'var(--mantine-color-brand-7)' : item.disabled ? 'var(--mantine-color-gray-5)' : 'var(--mantine-color-gray-8)',
                fontWeight: isActive ? 600 : 500,
                fontSize: 14,
                cursor: item.disabled ? 'not-allowed' : 'pointer',
              }}
            >
              {item.icon}
              <span style={{ flex: 1 }}>{item.label}</span>
              {item.badge && (
                <Box style={{
                  fontSize: 9, fontWeight: 600, letterSpacing: 0.3,
                  padding: '2px 6px', borderRadius: 999,
                  background: 'var(--mantine-color-gray-1)',
                  color: 'var(--mantine-color-gray-6)',
                  textTransform: 'uppercase',
                }}>{item.badge}</Box>
              )}
            </UnstyledButton>
          );
        })}
      </Stack>
      <Box
        mt="md"
        style={{
          padding: '10px 12px',
          borderTop: '1px solid var(--mantine-color-gray-2)',
        }}
      >
        <Group gap={6} wrap="nowrap" align="center">
          <Box style={{ width: 6, height: 6, borderRadius: 3, background: 'var(--mantine-color-teal-6)' }} />
          <Text fz={11} c="dimmed">Worker online</Text>
        </Group>
      </Box>
    </Box>
  );
}
